import { Link } from 'react-router-dom'

export default function Policies() {
  return (
    <div className="min-h-screen bg-white dark:bg-black px-4 sm:px-8 py-12">
      <div className="max-w-3xl mx-auto">

        <Link to="/" className="text-xs text-gray-400 hover:text-gray-900 dark:hover:text-white uppercase tracking-widest font-bold transition-colors mb-8 inline-block">
          ← Back
        </Link>

        <h1 className="text-3xl sm:text-4xl font-black uppercase tracking-tight text-gray-900 dark:text-white mb-2">
          Refund & Cancellation Policy
        </h1>
        <p className="text-gray-400 text-sm mb-10">Last updated: April 2026</p>

        <div className="flex flex-col gap-10 text-gray-600 dark:text-gray-400 text-sm leading-relaxed">

          <section>
            <h2 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white mb-3">
              1. Membership Subscriptions
            </h2>
            <p>
              Membership subscription fees are non-refundable once payment has been processed. Subscriptions are valid for the duration of the current season as configured by the club. If you believe a payment was made in error, please contact the club administrator directly within 7 days of the transaction.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white mb-3">
              2. Shop Orders — Cancellations
            </h2>
            <p>
              Orders may be cancelled before they are marked as fulfilled. To request a cancellation, contact the club shop administrator as soon as possible after placing your order. Once an order has been fulfilled and dispatched, it cannot be cancelled.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white mb-3">
              3. Shop Orders — Refunds
            </h2>
            <p>
              Refunds are considered in the following circumstances:
            </p>
            <ul className="list-disc list-inside mt-2 flex flex-col gap-1">
              <li>The item received is significantly different from the item described</li>
              <li>The item arrived damaged or defective</li>
              <li>The item was not delivered within a reasonable timeframe</li>
            </ul>
            <p className="mt-3">
              Refund requests must be submitted within 14 days of the delivery date. Approved refunds will be processed to the original payment method within 7–10 business days. Shipping costs are non-refundable unless the return is due to our error.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white mb-3">
              4. Welfare Donations
            </h2>
            <p>
              Donations made to welfare campaigns are voluntary and non-refundable. All donations go directly to the stated campaign beneficiary. The club is not able to reverse donation transactions once processed.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white mb-3">
              5. How to Contact Us
            </h2>
            <p>
              For any refund or cancellation requests, please contact the club administration team directly through the platform or reach out via the club's official communication channels. Include your membership ID, order reference, and a brief description of your request.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white mb-3">
              6. Changes to This Policy
            </h2>
            <p>
              Mighty Mufulira Wanderers FC reserves the right to update this policy at any time. Changes will be reflected on this page with an updated date.
            </p>
          </section>

        </div>
      </div>
    </div>
  )
}